<div>
  <div class='modal-header'>
    <h5 class='modal-title' id='modal-basic-title'>{{ this.statusDetails.title }}</h5>
    <button type='button' class='btn-close' aria-label='Close' (click)='activeModal.dismiss()'>
    </button>
  </div>
  <div class='modal-body'>
    <p>{{ this.statusDetails.message }}</p>
    <div *ngIf="this.sortedDetails">
      <div class="mb-2" *ngFor="let item of this.sortedDetails">
        <ejs-textbox placeholder="{{item[0]}}" value="{{item[1]}}" floatLabelType="Always" readonly></ejs-textbox>
      </div>
      <div *ngIf="this.statusDetails.title == 'Delete User Group' && this.statusDetails.details.numberOfUsers > 0">
        <ejs-dropdownlist placeholder="New Group" cssClass="e-outline" [dataSource]='groupList' [fields]='fields'
          id="newGroup" [(ngModel)]='newGroupId' name="newGroup"></ejs-dropdownlist>
      </div>
    </div>
    <div *ngIf="this.firmwareError && this.errorMessage != null">
      <ejs-message severity="Error" [showIcon]="false">
        <!-- <i class="fa-solid fa-xmark text-danger"></i> Error -->
        {{errorMessage}}
      </ejs-message>
    </div>
  </div>
  <div class="modal-footer">
    <div *ngIf="!this.firmwareError">
      <button ejs-button data-id="Confirmation Dialog Close Clicked" (click)="activeModal.dismiss()">Close</button>
    </div>
    <ng-container
      *ngIf="this.statusDetails.title == 'Delete User Group' && this.statusDetails.details.numberOfUsers > 0; then deleteGroup else otherModal">
    </ng-container>
  </div>

  <ng-template #otherModal>
    <button ejs-button cssClass="e-primary" id="btnConfirm" name="confirm" data-id="Confirmation Dialog Confirm Clicked"
      (click)="confirmClick(); this.activeModal.close(true);">
      Confirm
    </button>
  </ng-template>
  <ng-template #deleteGroup>
    <button ejs-button cssClass="e-primary" id="btnConfirm" name="confirm" data-id="Confirmation Dialog Confirm Clicked"
      [disabled]="!newGroupId" (click)="confirmClick(); this.activeModal.close(newGroupId);">
      Confirm
    </button>
  </ng-template>